export enum UserScope {
  ADMIN_RW='saasadmin-rw',
  ADMIN_RO='saasadmin-ro',
  UPGRADE_COORDINATOR='saas-coordinator'
}
